import React, { useEffect, useState } from "react";
import Sidebar from "../../../../partials/aside/Sidebar";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import helperSpinner from "../../../../../helpers/spinner";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumbers from "../../../../../helpers/numbers";
import validationsFormsAddGift from "../../../../../validtions/forms/gift/add";

export default function RangeValue() {
  const [gift, setGift] = useState();
  const history = useHistory();
  const params = useParams();
  const giftID = params.giftChargeUserID;

  const [minAmount, setMinAmount] = useState(1000000);
  const [maxAmount, setMaxAmount] = useState(2000000);

  useEffect(() => {
    getGift();
  }, []);

  const inputMinAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setMinAmount(parseInt(number));
  };
  const inputMaxAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setMaxAmount(parseInt(number));
  };

  const inputAmountBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const [message, setMessage] = useState();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const scrollForSeeMessage = () => {
    const element = document.querySelector(".container-fluid ");
    element.scrollIntoView();
  };

  const getGift = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetGift = await sendRequestGetGift();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetGift) {
      return;
    }

    setGift(resultSendRequestGetGift);
  };

  const sendRequestGetGift = async () => {
    let headersRequest = getHeaderForRequest();
    let gift;
    try {
      gift = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/gift-charge/${giftID}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return gift.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getDataForm = () => {
    return {
      min_amount: minAmount,
      max_amount: maxAmount,
      percent: document.querySelector("#percent").value,
    };
  };

  const sendForm = async () => {
    const dataForm = getDataForm();
    const resultValidationsFormsAddGift = validationsFormsAddGift(dataForm);
    if (resultValidationsFormsAddGift != true) {
      setMessage({
        type_class: "alert alert-danger ",
        text: resultValidationsFormsAddGift,
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddRangeToGift = await sendRequestAddRangeToGift(
      giftID,
      dataForm
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestAddRangeToGift) {
      return;
    }
    getGift();
  };

  const sendRequestAddRangeToGift = async (giftID, range) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/gift-charge/${giftID}/add-range`,
        range,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return true;
  };

  const deleteRange = async (rangeID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetGift = await sendRequestDeleteRange(rangeID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetGift) {
      return;
    }

    getGift();
  };

  const sendRequestDeleteRange = async (rangeID) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.deleteRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/gift-charge/${giftID}/range-id/${rangeID}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return true;
  };

  const generateRangeGift = () => {
    if (!gift.conditions) {
      return;
    }
    const rateCharge = gift.conditions.range_charge;
    if (!rateCharge.length) {
      return (
        <div className="pt-2">
          <div className="alert alert-info">شما هیچ بازه ای ندارید.</div>
        </div>
      );
    }
    return (
      <div className="pt-2">
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>حداقل مبلغ</td>
                <td>حداکثر مبلغ</td>
                <td>درصد</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {rateCharge.map((item) => {
                return (
                  <tr>
                    <td className="number-finance">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(item.min)
                      )}
                    </td>
                    <td className="number-finance">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(item.max)
                      )}
                    </td>
                    <td className="number-finance">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(item.percent)
                      )}
                    </td>
                    <td>
                      <span>
                        <span
                          className="btn btn-danger  btn-danger"
                          onClick={() => deleteRange(item.id)}
                        >
                          <i className="fa fa-trash"></i>
                        </span>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-finance" activeItem="gift-charge-user" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  بازه ی مالی هدایای افزایش اعتبار
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  className="btn btn-primary"
                  to="/finance/manage/gift-charge-user/all"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {messageTag}
              {gift && generateRangeGift()}
              <hr />
              <div className="alert alert-warning ">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>
                  توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">حداکثر مبلغ جز بازه نیست </p>
                  </li>
                </ul>
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  sendForm();
                }}
              >
                <div className="py-2">
                  <div className="pb-2 text-right">حداقل مبلغ</div>
                  <div>
                    <div class="input-group">
                      <input
                        onWheel={(event) => event.currentTarget.blur()}
                        type="text"
                        class="form-control number-finance"
                        value={helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(minAmount)
                        )}
                        onChange={inputMinAmountChangeHandler}
                        onBeforeInput={inputAmountBeforeInputHandler}
                        dir="ltr"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">تومان</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="py-2">
                  <div className="pb-2 text-right">حداکثر مبلغ</div>
                  <div>
                    <div class="input-group">
                      <input
                        onWheel={(event) => event.currentTarget.blur()}
                        type="text"
                        class="form-control number-finance"
                        value={helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(maxAmount)
                        )}
                        onChange={inputMaxAmountChangeHandler}
                        onBeforeInput={inputAmountBeforeInputHandler}
                        dir="ltr"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">تومان</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex py-2">
                  <span className="pl-2">
                    <label>درصد : </label>
                  </span>
                  <span>
                    <input
                      style={{ width: "50px" }}
                      tabIndex="1"
                      onWheel={(event) => event.currentTarget.blur()}
                      dir="rtl"
                      type="number"
                      id="percent"
                      max="99"
                      min="1"
                      className="form-control"
                      required
                    />
                  </span>
                </div>
                <div>
                  <button className="btn btn-success">اضافه کردن</button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
